<template>
  <div>
    <create-certificate></create-certificate>
  </div>
</template>

<script>
import CreateCertificate from '@/components/Ssl/CreateCertificate'

export default {
  name: 'SslCreate',
  components: {
    CreateCertificate,
  }
}
</script>
